module.exports = __webpack_public_path__ + "05_medium_brown.204e4bc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/05_medium_brown.png
// module id = n1Zm
// module chunks = 0